<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/h1cxUi/tc-custom/9781610583442.jpg?1702008029843" alt="This image is the cover for the book Acrylic Artist's Bible"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Acrylic Artist's Bible
      </h1>
      <p class="bookDescription body article font2">
        <b>This guide to painting techniques and subjects includes photos, diagrams and illustrations, providing instruction for both beginner and advanced artists.</b><br/><br/>With its great flexibility, acrylic paint can mimic the appearance of oils, tempera, and watercolors in unique ways, each method pictured in a separate step-by-step demonstration. The author also examines the use of acrylics with airbrush, sculptural, and printing techniques—even three-dimensional relief painting and collagraph printing methods are included—and how several of these different creative processes can be integrated successfully in one composition with ink, pencil, charcoal, and pastel. Inspiring examples of representational and abstract subjects are depicted throughout, and a complete survey of all the latest acrylic materials covers the best paint brands, painting mediums, supports, varnishes, brushes, knives, and palettes.<br/><br/>This book contains instructions on painting many different subjects, like landscapes, trees, mountains, buildings, still lifes, and portraits. It makes an ideal gift for someone practiced in the arts of acrylic painting, and newcomers to the art form.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Marylin Scott
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Chartwell Books, Inc.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?56a81eca